import React from "react";
import { Box } from "@mui/material";
import TimeOfDayOfWeekContent from "./TimeOfDayOfWeekContent";
import withQueryWidget, { WithQueryWidgetProps } from "components/widgetParts/queryWidgetComposition/withQueryWidget";
import { getSingleOriginalRequestByName, getSingleWidgetResponseByName } from "system/widget/Widget";
import { defaultSettings, KeywordDisplayType } from "./TimeOfDayOfWeekSettings";
import { useTranslation } from "react-i18next";

function TimeOfDayOfWeek(props: WithQueryWidgetProps): JSX.Element {
  const { i18n } = useTranslation();

  const apiResponseInfo = getSingleWidgetResponseByName(props.apiResponses, 'time-of-day-of-week');
  const originalRequest = getSingleOriginalRequestByName(props.activeWidgetRequests, 'time-of-day-of-week');

  const currentState = {
    ...defaultSettings,
    ...props.widget?.data?.settings
  };

  const isNetValue = currentState.keywordDisplayType === KeywordDisplayType.NET;

  const originalAggs = originalRequest?.requestInit?.body?.aggs?.time_of_day_of_week;
  const originalSubagg = originalAggs?.aggs?.subagg;
  const originalAggsFilter = originalSubagg?.filter;
  const originalSubaggOp = originalSubagg?.op;

  const subAggOpLabel : string | undefined = ["social_universe", "keyword", "keywords"].includes(originalSubaggOp || "") ? undefined : originalSubaggOp;

  const topField = isNetValue && originalAggsFilter?.length ? originalAggsFilter[0] : undefined;

  let fieldLabel = originalAggs?._subagg_label;
  if (!fieldLabel) {
    if (originalSubagg?.op === "social_universe") {
      fieldLabel = i18n.t("social_universe");
    } else if (originalSubagg?.field) {
      fieldLabel = originalSubagg?.field;
    } else {
      fieldLabel = i18n.t("records");
    }
  }

  return (
    <Box sx={{ height: "100%", width: "100%" }}>
      <TimeOfDayOfWeekContent
        settingsState={currentState}
        fieldLabel={fieldLabel}
        subAggOpLabel={subAggOpLabel}
        topField={topField}
        apiResponseBody={apiResponseInfo?.responseBody}
        queryDisplayTitle={apiResponseInfo?.queryDisplayTitle}
        widget = {props.widget}
      />
    </Box>
  );
}

export default withQueryWidget(TimeOfDayOfWeek, {
  hasSettingsDialog: true,
  hasQueryDialog: true
});
